export default class Message {
	constructor({date, managed_response, message_received, position, seen, state, user_name, key, resource_id}) {
		this.date = date || "";
		this.managed_response = managed_response || "";
		this.message_received = message_received || "";
		this.position = position;
		this.seen = seen || true;
		this.state = state || "";
		this.user_name = user_name || "";
		this.key = key || "";
		this.resource_id = resource_id || 0;
	}
}
